import { Component, OnDestroy, OnInit, Type } from "@angular/core";
import {
    BaseComponent,
    CommonService,
    DataSource,
    PusherService,
    FeatureFlagService,
    Shared,
    UserService,
    MessageService,
} from "@rubii/frontend-common";
import { ItemResponse } from "@rubii/frontend-common/lib/models/common/Response";
import { ConfigService } from "../../services/config.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { DatasourceConnectionComponent } from "../datasource-connection/datasource-connection.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Dictionary } from "@rubii/frontend-common/lib/models/common/Dictionary";
import { DatasourceService } from "./services/datasource.service";
import { SaveConfigService } from "./services/save-config.service";
import { Dv360Component } from "./dv360/dv360.component";
import { DcmComponent } from "./dcm/dcm.component";
import { Sa360Component } from "./sa360/sa360.component";
import { GAdsComponent } from "./gads/gads.component";
import { BaseDatasourceComponent } from "./base-datasource/base-datasource.component";
import { WsEvent } from "@rubii/frontend-common/lib/models/events/ws-event.class";
import { ClientService } from "../../services/client.service";
import { HttpException } from "@rubii/share/src/classes";
import { DataSourceListData } from "@rubii/sdk-web-user/src/types/data-source-list-data.type";
import { DatasourceDetailComponent } from "./datasource-detail/datasource-detail.component";
import { Dsps } from '@rubii/share/src/constants';
import { featureEntraSso, featureGoogleSso, featurePubmatic, featureScope3, featureSeedooh, featureXero } from "../../constants/features";
import { GamComponent } from './gam/gam.component';
import { EntraConfig, GoogleSsoConfig } from "@rubii/share/src/classes/data-source-config";
import { EntraConfigComponent } from "../entra-config/entra-config.component";
import { GoogleSsoConfigComponent } from "../google-sso-config/google-sso-config.component";

declare var FB: any;
// declare var amazon: any;

@Component({
    selector: "app-datasource",
    templateUrl: "./datasource.component.html",
    styleUrls: ["./datasource.component.scss"],
})
export class DatasourceComponent extends BaseComponent implements OnInit, OnDestroy {

    allDataSources: DataSource[] = [];
    search: FormControl;
    channel: any;
    loading: string;
    prefilledDataSourceId: number;

    dataSourceIdsRelyOnGmailImport = [Dsps.AS, Dsps.DV, Dsps.IAS, Dsps.BLIS, Dsps.CF];

    url: string;
    subscriptions: any[] = [];

    frontEndGroups: { [index: number]: string } =
        Shared.dicts.DataSourceFrontEndGroups;
    groupedDataSources: Array<{ groupId: number; dataSources: DataSource[] }> =
        [];

    dataSourceClass: Type<BaseDatasourceComponent>;

    constructor(
        private config: ConfigService,
        private snack: MatSnackBar,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private client: ClientService,
        private user: UserService,
        private feature: FeatureFlagService,
        private router: Router,
        private location: Location,
        private message: MessageService<any>,
        private pusher: PusherService,
        private datasourceService: DatasourceService,
        private saveConfigService: SaveConfigService
    ) {
        super();
        this.allDataSources = [];
        this.getDataSources(false);
        this.search = new FormControl("", {});
        console.log('======== data source component ========');
    }

    hasError(source: DataSourceListData): any {
        return source.statusList?.statusList?.some(status => status.status.toLowerCase().includes('error'));
    }

    dataSourceDetail(event: MouseEvent, source: DataSourceListData): any {
        event.stopPropagation();
        let dialogRef = this.dialog.open(DatasourceDetailComponent, {
            data: { source },
        });
    }
    authorisedCodes: { [index: string]: 1 } = {};

    ngOnDestroy(): void {
        if (this.subscriptions?.length > 0) {
            this.subscriptions.forEach(sub => sub.unsubscribe());
        }
    }

    async ngOnInit() {
        this.subscriptions.push(
            this.message.msg.subscribe(ret => {
                if (ret && ret.id === 'data-source-dialog-closed-' + Dsps.ENTRA) {
                    this.waitForEntra(ret.value.payload, ret.value.domain);
                }
                if (ret && ret.id === 'data-source-dialog-error-' + Dsps.ENTRA) {
                    this.hideMask();
                }
                if (ret && ret.id === 'data-source-dialog-closed-' + Dsps.GOOGLE_SSO) {
                    this.waitForGoogleSso(ret.value.payload, ret.value.domain);
                }
            })
        )

        // TODO: Remove - test entraCreated dialog
        // this.entraCreated({ shortname: 'test' } as EntraConfig, 'test.rubiiaws.io', {});

        this.pusher.bind("data-source", "deleted", (data: WsEvent) => {
            this.dataSourceDeletedHandler(data, "identifier");
        });

        this.pusher.bind("data-source", "deletedByEmail", (data: WsEvent) => {
            this.dataSourceDeletedHandler(data, "email");
        });

        let self = this;
        // Init FB
        FB.init({
            appId: self.config.fbAppId,
            autoLogAppEvents: true,
            xfbml: true,
            version: "v26.0",
        });

        for (const k in Shared.dicts.DataSourceFrontEndGroups) {
            this.groupedDataSources.push({
                groupId: parseInt(k),
                dataSources: [],
            });
        }

        this.activatedRoute.queryParams.subscribe((params) => {
            if (params.sf) {
                const shopName = atob(decodeURIComponent(params.sf));
                this.client.account.generateShopifyAuthUrl({ dataSourceId: Dsps.SHOPIFY, shopName }).then(res => {
                    this.openSnackBar(this.snack, 'Your store is connected.', 'closed');
                    setTimeout(() => {
                        this.router.navigate(['../../datasources']);
                    }, 1000);
                }).catch(e => {
                    this.openSnackBarWarning(this.snack, e.message, 'closed');
                });
            }

            if (params.type) {
                this.saveConfigService
                    .getHandler(params.type.replace(/-/g, '_'))  // some data source type contains '-'
                    .call(
                        this.saveConfigService,
                        params,
                        this.getDataSources.bind(this),
                        this.openSnackBar.bind(this),
                        this.openSnackBarWarning.bind(this),
                        this.snack
                    );
            } else if (params.code) {
                // google
                if (
                    params.scope &&
                    params.scope
                        .split(" ")
                        .includes(
                            "https://www.googleapis.com/auth/analytics.readonly"
                        )
                ) {
                    this.saveConfigService.saveGAConfig(
                        params,
                        this.getDataSources.bind(this),
                        this.openSnackBar.bind(this),
                        this.openSnackBarWarning.bind(this),
                        this.snack
                    );
                } else if (
                    params.scope &&
                    params.scope
                        .split(" ")
                        .includes(
                            "https://www.googleapis.com/auth/webmasters.readonly"
                        )
                ) {
                    this.saveConfigService.saveSEOConfig(
                        params,
                        this.getDataSources.bind(this),
                        this.openSnackBar.bind(this),
                        this.openSnackBarWarning.bind(this),
                        this.snack
                    );
                } else if (
                    params.scope &&
                    params.scope
                        .split(" ")
                        .includes(
                            "https://www.googleapis.com/auth/youtube.readonly"
                        )
                ) {
                    this.saveConfigService.youtubeorganic(
                        params,
                        this.getDataSources.bind(this),
                        this.openSnackBar.bind(this),
                        this.openSnackBarWarning.bind(this),
                        this.snack
                    );
                } else {
                    this.saveGoogleCode(
                        params.code,
                        params.scope,
                        params.state
                    );
                }
            }

            if (params.dataSourceId) {
                this.prefilledDataSourceId = params.dataSourceId;
            }
        });
    }

    getDataSources(replaceState = true) {
        if (replaceState) {
            this.location.replaceState("datasources");
        }
        this.client.account.dataSources().then(result => {
            this.allDataSources = result as DataSource[];

            this.allDataSources.forEach((ds) => {
                ds.frontEndGroup =
                    Shared.dicts.DataSourceFrontEndGroupMapping[ds.id];
                ds.frontEndOrder = Shared.dicts.DataSourceFrontEndOrder[ds.id];
            });

            this.feature.register([featureXero, featureScope3, featureGoogleSso, featureEntraSso, featurePubmatic, featureSeedooh]).then(() => {
                // This is used to temporarily hide data sources that are not ready for production
                if (window.location.host === 'app.rubii.io') {
                    const hideDataSources = this.getDataSourcesToHide();
                    this.allDataSources = this.allDataSources.filter(ds => !hideDataSources.includes(ds.id));
                }

                if (this.prefilledDataSourceId) {
                    this.allDataSources = this.allDataSources.filter(ds => ds.id == this.prefilledDataSourceId);
                }

                this.allDataSources = this.allDataSources.sort((a, b) =>
                    a.frontEndOrder < b.frontEndOrder
                        ? -1
                        : a.frontEndOrder > b.frontEndOrder
                            ? 1
                            : 0
                );
                this.filterDataSources();
            });
        }).catch(e => {
            this.openSnackBarWarning(this.snack, (e as HttpException).message, "close");

        });
    }

    async filterDataSources(searchValue?: string) {
        this.groupedDataSources.forEach((gds) => (gds.dataSources = []));
        this.allDataSources.forEach((source) => {
            if (
                Shared.helpers.UtilHelper.empty(searchValue) ||
                source.name.toLowerCase().indexOf(searchValue.toLowerCase()) >=
                0
            ) {
                const foundGroup = this.groupedDataSources.find(
                    (g) => g.groupId === source.frontEndGroup
                );
                if (foundGroup) {
                    foundGroup.dataSources.push(source);
                }
            }
        });

        const dspIds = this.allDataSources.filter(source => source.activated).map(source => source.id);
        if (dspIds.length > 0) {
            const results = await this.client.account.getEnabledDataSourceStatus(dspIds);
            this.allDataSources.forEach((source: DataSourceListData) => {
                const result = results[source.id];
                if (result) {
                    source.statusList = result;
                    source.activated = result.statusList.length;
                }
            });
        }
    }

    async connectDataSource(dataSourceId: number) {
        const datasource = this.allDataSources.find(
            (source) => source.id === dataSourceId
        );
        const handler = this.datasourceService.getHandler(datasource.shortname.toLowerCase());
        if (handler) {
            if (dataSourceId === Dsps.ENTRA) {

            }
            await handler.call(
                this.datasourceService,
                dataSourceId,
                this.getDataSources.bind(this),
                this.openSnackBar.bind(this),
                this.openSnackBarWarning.bind(this),
                this.snack,
                "close",
                FB,
                datasource.logo,
            );
        } else {
            this.openSnackBar(this.snack, 'Please contact rubii support to connect this data source.', 'close');
        }
    }

    saveGoogleCode(googleCode: string, scope: string, state: string) {
        let scopes = scope.split(" ");
        let datasourceId;
        if (
            scopes.includes(
                "https://www.googleapis.com/auth/doubleclickbidmanager"
            )
        ) {
            datasourceId = Shared.dicts.DataSources.DV360;
            this.dataSourceClass = Dv360Component;
            this.loading = "Connecting to DV360, please wait...";
        } else if (scopes.some((s) => s.includes("dfareporting"))) {
            datasourceId = Shared.dicts.DataSources.CM;
            this.dataSourceClass = DcmComponent;
            this.loading = "Loading profiles, please wait...";
        } else if (
            scopes.includes("https://www.googleapis.com/auth/doubleclicksearch")
        ) {
            datasourceId = Shared.dicts.DataSources.SA360;
            this.dataSourceClass = Sa360Component;
            this.loading = "Loading agencies, please wait...";
        } else if (scope.includes('dfp') || scope.includes('admanager')) {
            datasourceId = Shared.dicts.DataSources.GAM;
            this.dataSourceClass = GamComponent;
            this.loading = "Loading networks, please wait...";
        } else {
            datasourceId = Shared.dicts.DataSources.GADS;
            this.dataSourceClass = GAdsComponent;
            this.loading = "Loading login customers, please wait...";
        }
        this.createMask();
        let input = {
            code: googleCode,
            dataSourceId: datasourceId,
            state,
        };
        this.client.account.fetchAndSaveDV360Token(input).then(result => {
            if (datasourceId === Shared.dicts.DataSources.GADS) {
                this.pusher.bind(
                    "google-user-profile-" + datasourceId,
                    "get-user-profiles",
                    this.fetchSucceeded.bind(this)
                );
            } else if (datasourceId === Shared.dicts.DataSources.GAM) {
                this.fetchSucceeded({ data: result });
            } else {
                this.fetchSucceeded({ data: result });
            }
        }).catch(e => {
            this.loading = undefined;
            this.hideMask();
            this.openSnackBarWarning(this.snack, (e as HttpException).message, "close");
        });
    }

    createMask(msg?: string) {
        const mask = document.getElementById("loading-mask");
        const loading = document.getElementById("loading");
        mask.style.display = "";
        loading.style.display = "";
        loading.innerText = msg || this.loading;
    }

    waitForEntra(payload: EntraConfig, domain: string) {
        this.createMask("Setting up Entra SSO...");
        this.pusher.bind('entra-config-' + payload.shortname, 'created', this.entraCreated.bind(this, payload, domain));
        this.pusher.bind('entra-config-' + payload.shortname, 'error', this.entraError.bind(this));
    }

    entraError(event: WsEvent) {
        this.hideMask();
        this.pusher.unbind('entra-config-' + event.data.shortname);
        const payload = event.data as HttpException;
        this.openSnackBarWarning(this.snack, payload?.message || 'Failed to set up Entra SSO. Please try again.', 'close');
    }

    entraCreated(payload: EntraConfig, domain: string, data: any) {
        this.hideMask();
        this.pusher.unbind('entra-config-' + payload.shortname);
        this.dialog.open(EntraConfigComponent, {
            data: { payload, domain }
        });
    }

    waitForGoogleSso(payload: GoogleSsoConfig, domain: string) {
        this.createMask("Setting up Google SSO...");
        this.pusher.bind('google-sso-config-' + payload.shortname, 'created', this.googleSsoCreated.bind(this, payload, domain));
    }

    googleSsoCreated(payload: GoogleSsoConfig, domain: string, data: any) {
        this.hideMask();
        this.pusher.unbind('google-sso-config-' + payload.shortname);
        this.dialog.open(GoogleSsoConfigComponent, {
            data: { payload, domain }
        });
    }

    hideMask() {
        const mask = document.getElementById("loading-mask");
        const loading = document.getElementById("loading");
        mask.style.display = "none";
        loading.style.display = "none";
    }

    async fetchSucceeded(data: { data: any }) {
        this.loading = undefined;
        this.hideMask();
        await this.openDialog(data.data);
    }

    dataSourceDeletedHandler(data: WsEvent, filterKey: "identifier" | "email") {
        const { dspId } = data.data;
        const filterValue = data.data[filterKey];

        const dataSource = this.allDataSources.find(ds => ds.id === dspId) as DataSourceListData;
        if (dataSource.statusList?.statusList) {
            dataSource.statusList.statusList = dataSource.statusList.statusList.filter(s => s[filterKey] !== filterValue);
            dataSource.activated = dataSource.statusList.statusList.length;
        }
    }

    async openDialog(data: any) {
        let dialogRef = this.dialog.open(DatasourceConnectionComponent, {
            data: { ...data, dataSourceClass: this.dataSourceClass },
        });
        dialogRef.afterClosed().subscribe((data) => {
            this.pusher.unbind("google-user-profile-" + data.dataSourceId);
            this.getDataSources();
        });
    }

    getDataSourcesToHide() {
        const toHide = [];
        if (this.user.user.tenant.id !== 2 && this.user.user.tenant.id !== 51 && this.user.user.tenant.id !== 9) {
            toHide.push(Dsps.SHOPIFY);
        }
        if (this.user.user.tenant.id !== 1 && this.user.user.tenant.id !== 2 && this.user.user.tenant.id !== 61) { // Trapper
            toHide.push(Dsps.YAHOOJP);
        }

        if (![
            1, // Rubii
            51, // HotGlue
            73, // OMG
            39, // Goodman Fielder - Retail
            54, // Goodman Fielder - RFS
        ].includes(this.user.user.tenant.id)) {
            toHide.push(Dsps.HUBSPOT);
        }
        if (!this.feature.featureEnabled[featureXero]) {
            toHide.push(Dsps.XERO);
        }
        if (!this.feature.featureEnabled[featureScope3]) {
            toHide.push(Dsps.SCOPE3);
        }
        if (!this.feature.featureEnabled[featureGoogleSso]) {
            toHide.push(Dsps.GOOGLE_SSO);
        }
        if (!this.feature.featureEnabled[featureEntraSso]) {
            toHide.push(Dsps.ENTRA);
        }
        if (!this.feature.featureEnabled[featurePubmatic]) {
            toHide.push(Dsps.PUBMATIC);
        }
        if (!this.feature.featureEnabled[featureSeedooh]) {
            toHide.push(Dsps.SEEDOOH);
        }

        return toHide;
    }
}
